<script setup lang="ts">
import type { ImgHTMLAttributes } from "vue"
import { cn } from "~/lib/utils"

const { src, alt, class: cl, style, loading } = defineProps<{
    src: string
    alt?: string
    class?: string
    style?: string
    loading?: ImgHTMLAttributes["loading"]
}>()

// TODO: Resolve issues and test in .github/workflows/preview.yml
// const optimize = import.meta.env.MODE === "production"
// const optimalType = "image/avif"
// const optimalSrc = computed(() => src.split(".").slice(0, -1).join(".") + "." + optimalType.split("/")[1])
</script>

<template>
    <picture>
        <!--<source
            v-if="optimize"
            :srcset="optimalSrc"
            :type="optimalType"
        >!-->
        <img
            :src="src"
            :alt="alt"
            :loading="loading"
            :class="cn('min-h-full object-cover', cl)"
            :style="style"
        >
    </picture>
</template>